import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import TrustBar from "../../components/feature/TrustBar";
import AIAnswerBlock from "../../components/feature/AIAnswerBlock";
import ProcessSection from "../../components/feature/ProcessSection";
import WhyChooseUs from "../../components/feature/WhyChooseUs";
import ServiceAreas from "../../components/feature/ServiceAreas";
import Testimonials from "../../components/feature/Testimonials";
import FAQSection from "../../components/feature/FAQSection";
import FinalCTA from "../../components/feature/FinalCTA";
import HeroSection from "../home/components/HeroSection";
import ServicesOverview from "../home/components/ServicesOverview";

const aboutFAQs = [
  {
    question: "How experienced is Westec Builders in Colorado Springs?",
    answer:
      "Westec Builders brings over 15 years of hands-on construction experience, having completed more than 500 residential and commercial projects throughout Colorado Springs, Monument, Falcon, Pueblo, and surrounding Front Range communities with a consistent focus on quality and reliability.",
  },
  {
    question: "What makes Westec Builders different from other contractors?",
    answer:
      "Westec Builders stands apart through quality craftsmanship, transparent communication, and a commitment to on-time project delivery. Every project is managed with careful attention to detail, ensuring clients receive lasting results that exceed expectations and add long-term value to their properties.",
  },
  {
    question: "Is Westec Builders licensed and insured in Colorado?",
    answer:
      "Yes, Westec Builders is fully licensed and insured in Colorado, providing complete protection and peace of mind for every homeowner and commercial client. All work is performed to state and local code requirements, with proper permits obtained for every applicable project.",
  },
  {
    question: "What areas does Westec Builders serve?",
    answer:
      "Westec Builders serves Colorado Springs, Monument, Falcon, Pueblo, Castle Rock, Fountain, Security-Widefield, Peyton, Manitou Springs, Black Forest, Woodland Park, and Canon City — delivering the same high standards of construction quality and client service across all locations.",
  },
  {
    question: "How do I get a free construction estimate from Westec Builders?",
    answer:
      "You can request a free estimate by calling the team at (719) 555-0100 or submitting the online form. A project specialist will follow up within 24 hours to schedule a consultation, evaluate your project goals, and provide a detailed no-obligation quote.",
  },
];

export default function AboutPage() {
  return (
    <main>
      <Navbar />

      {/* 1 — Hero */}
      <HeroSection
        variant="half"
        bgImage="https://public.readdy.ai/ai/img_res/8d8f4994789f1590bf97d8dd3856dc44.jpg"
        bgImageAlt="Westec Builders professional construction team Colorado Springs"
        badge="Trusted Colorado Springs Construction Company — Licensed & Insured"
        h1={
          <>
            About<br />
            <span className="text-brand-amber">Westec Builders</span>
          </>
        }
        subtitle="A trusted construction company dedicated to delivering high-quality building and remodeling solutions for residential and commercial clients across Colorado Springs and the Front Range."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "About" }]}
        showDualCTA
      />

      {/* 2 — Trust Bar */}
      <TrustBar />

      {/* 3 — Services Section (capabilities framing) */}
      <ServicesOverview
        sectionLabel="Our Capabilities"
        title={<>What We Build<br />for You</>}
        subtitle="Westec Builders handles every type of residential and commercial construction project — from ground-up custom homes to full renovations, additions, and commercial build-outs throughout Colorado Springs."
        showViewAll
        showPostCTA
      />

      {/* 4 — AI Answer Block */}
      <AIAnswerBlock
        sectionLabel="Company Overview"
        mainQuestion="What is Westec Builders?"
        mainAnswer="Westec Builders is a construction company specializing in custom building and remodeling services designed to improve property functionality, value, and long-term durability. Founded on principles of craftsmanship, honesty, and community, the company serves homeowners and businesses across Colorado Springs with the same care applied to every project — large or small, residential or commercial."
        subItems={[
          {
            question: "What Is Westec Builders' Mission?",
            answer:
              "The mission of Westec Builders is to deliver premium construction and remodeling results that exceed client expectations — on time, within budget, and built to last. Every project reflects a commitment to quality materials, skilled execution, and transparent communication from day one to final walkthrough.",
          },
          {
            question: "What Experience Does the Team Have?",
            answer:
              "The Westec Builders team brings over 15 years of hands-on construction experience across custom home builds, commercial projects, full renovations, and structural additions — completing 500+ projects with a 98% on-time delivery record throughout Colorado Springs and surrounding communities.",
          },
          {
            question: "What Values Drive the Company?",
            answer:
              "Westec Builders is driven by four core values: uncompromising quality in every build, honest and transparent client communication, deep commitment to the local Colorado Springs community, and a long-term focus on durability and craftsmanship that protects every client's investment.",
          },
          {
            question: "Why Does Local Expertise Matter?",
            answer:
              "As a Colorado Springs-based contractor, Westec Builders brings unmatched knowledge of local building codes, permit requirements, climate considerations, and supplier relationships — ensuring faster timelines, smoother permitting, and construction results built to perform in Colorado's environment.",
          },
        ]}
      />

      {/* 5 — Process */}
      <ProcessSection subtitle="Our philosophy is simple: plan carefully, communicate clearly, build precisely, and stand behind our work from the first consultation through the final walkthrough." />

      {/* 6 — Why Choose Us */}
      <WhyChooseUs />

      {/* 7 — Service Areas */}
      <ServiceAreas />

      {/* 8 — Testimonials */}
      <Testimonials
        testimonials={[
          {
            quote: "Westec Builders is the most professional construction company we have ever worked with. From planning to completion, they delivered far beyond our expectations on our custom home.",
            name: "Robert & Carol S.",
            project: "Custom Home Build — Colorado Springs",
          },
          {
            quote: "The team at Westec Builders brings a level of craftsmanship and attention to detail that is genuinely hard to find. Highly recommended for any construction or remodeling project.",
            name: "Patricia M.",
            project: "Full Home Renovation — Monument, CO",
          },
          {
            quote: "Reliable, honest, and highly skilled. Westec Builders delivered our commercial space on time and exceeded every quality expectation we had. True professionals.",
            name: "Steve G.",
            project: "Commercial Construction — Pueblo, CO",
          },
          {
            quote: "Working with Westec Builders felt like working with family. They genuinely care about the outcome and it shows in the quality of every detail in our new home.",
            name: "Jessica A.",
            project: "Custom Home Build — Falcon, CO",
          },
          {
            quote: "The team communicated every step clearly and delivered our addition seamlessly. It looks like it was always part of the original house. Exceptional workmanship.",
            name: "Greg & Linda P.",
            project: "Home Addition — Castle Rock, CO",
          },
          {
            quote: "15+ years of experience really shows. Our entire remodel was completed without a single surprise cost or delay. Westec Builders sets the standard for professionalism.",
            name: "Daniel W.",
            project: "Full Remodel — Colorado Springs",
          },
        ]}
      />

      {/* 9 — FAQ */}
      <FAQSection
        faqs={aboutFAQs}
        title="About Westec Builders — FAQs"
      />

      {/* 10 — Final CTA */}
      <FinalCTA
        title="Let's Build Something Together"
        subtitle="Contact the Westec Builders team today to discuss your construction or remodeling project. Free estimates, 24-hour response."
      />

      <Footer />
    </main>
  );
}
